export * from './people-cards/people-cards.module';